var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { getFieldTitle } from "@rentiohq/shared-frontend/dist/redux/form/form.utils";
import { EContractCostsAreIndexable, EContractCostsPriceType, VAT_OPTIONS, VAT_OPTIONS_BOOKKEEPING, } from "@rentiohq/shared-frontend/dist/types/contract.types";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { isNumber } from "lodash";
import React, { useState, useEffect } from "react";
import { Button } from "../../../Button";
import { Grid } from "../../../Grid/Grid";
import { Label } from "../../../Labelled";
import { SegmentedControl } from "../../../SegmentedControl";
import { Select } from "../../../Select";
import { Stack } from "../../../Stack";
import { TextField } from "../../../TextField/TextField";
import * as S from "./AdditionalCost.styled";
var EAdditionalCostField;
(function (EAdditionalCostField) {
    EAdditionalCostField["Description"] = "description";
    EAdditionalCostField["StartPrice"] = "startPrice";
    EAdditionalCostField["CurrentPrice"] = "currentPrice";
    EAdditionalCostField["PriceVat"] = "priceVat";
    EAdditionalCostField["PriceNoVatType"] = "priceNoVatType";
    EAdditionalCostField["PriceType"] = "priceType";
    EAdditionalCostField["IsIndexable"] = "isIndexable";
})(EAdditionalCostField || (EAdditionalCostField = {}));
var getInitialCount = function (formData, name) {
    return (formData === null || formData === void 0 ? void 0 : formData[name]) ? Object.keys(formData[name]).length : 0;
};
export var AdditionalCosts = function (props) {
    var _a, _b;
    var name = props.name, onChange = props.onChange, formData = props.formData, formContext = props.formContext, uiSchema = props.uiSchema;
    var title = getFieldTitle(uiSchema, formContext);
    var allFormData = formContext.getAllFormData();
    var _c = useState(formData || {}), localFormData = _c[0], setLocalFormData = _c[1];
    var _d = useState(getInitialCount(allFormData, name)), addedAdditionalCostsCount = _d[0], setAddedAdditionalCostsCount = _d[1];
    var _e = React.useState([]), savedCosts = _e[0], setSavedCosts = _e[1];
    var _f = useState({}), validationErrors = _f[0], setValidationErrors = _f[1];
    useEffect(function () {
        setLocalFormData(formData || {});
    }, [formData]);
    var getAdditionalCostsKey = function (index) { return "additional-costs-".concat(index); };
    var isDisabled = uiSchema.isDisabled, buttonTitle = uiSchema.buttonTitle, 
    // showAddButton = true,
    isExistingContract = uiSchema.isExisting, showStartPrice = uiSchema.showStartPrice, bookkeepingEnabled = uiSchema.bookkeepingEnabled;
    var isExisting = (isExistingContract === null || isExistingContract === void 0 ? void 0 : isExistingContract(allFormData)) || false;
    var uiDisabled = isDisabled
        ? isDisabled(formContext.getAllFormData())
        : undefined;
    var getFieldKey = function (sectionKey, fieldKey) {
        return "".concat(sectionKey, "-").concat(fieldKey);
    };
    var getValue = function (sectionKey, fieldKey) { var _a; return localFormData ? (_a = localFormData[sectionKey]) === null || _a === void 0 ? void 0 : _a[fieldKey] : ""; };
    var validateSection = function (sectionKey, isExisting, data) {
        var _a;
        var errors = {};
        var section = (data === null || data === void 0 ? void 0 : data[sectionKey]) || {};
        if (!((_a = section.description) === null || _a === void 0 ? void 0 : _a.trim())) {
            errors.description = getLocalizedText("contract_info.description.required");
        }
        if (!showStartPrice && !section.currentPrice) {
            errors.currentPrice = getLocalizedText("contract_info.current_price.required");
        }
        if (showStartPrice && !section.startPrice) {
            errors.startPrice = getLocalizedText("contract_info.start_price.required");
        }
        if (section.priceVat === undefined || section.priceVat === "") {
            errors.priceVat = getLocalizedText("contract_info.vat_amount.required");
        }
        return errors;
    };
    var handleFieldChange = function (sectionKey, fieldKey, value) {
        var _a, _b;
        var newState = __assign(__assign({}, localFormData), (_a = {}, _a[sectionKey] = __assign(__assign({}, localFormData[sectionKey]), (_b = {}, _b[fieldKey] = value, _b)), _a));
        setLocalFormData(newState);
        setValidationErrors(function (prev) {
            var _a;
            var sectionErrors = __assign({}, prev[sectionKey]);
            delete sectionErrors[fieldKey];
            return __assign(__assign({}, prev), (_a = {}, _a[sectionKey] = sectionErrors, _a));
        });
    };
    var handleSaveSection = function (sectionKey) {
        var errors = validateSection(sectionKey, isExisting, localFormData);
        if (Object.keys(errors).length > 0) {
            setValidationErrors(function (prev) {
                var _a;
                return (__assign(__assign({}, prev), (_a = {}, _a[sectionKey] = errors, _a)));
            });
        }
        else {
            onChange(localFormData);
            setSavedCosts(function (prevState) { return __spreadArray(__spreadArray([], prevState, true), [sectionKey], false); });
            setValidationErrors(function (prev) {
                var updated = __assign({}, prev);
                delete updated[sectionKey];
                return updated;
            });
        }
    };
    var handleDeleteSection = function (key) {
        setSavedCosts(function (prevState) {
            return prevState.filter(function (sectionKey) { return sectionKey !== key; });
        });
        var state = __assign({}, localFormData);
        delete state[key];
        setLocalFormData(state);
        onChange(state);
    };
    var showAddButton = savedCosts.length === ((_a = Object.keys(localFormData)) === null || _a === void 0 ? void 0 : _a.length);
    return (_jsxs(_Fragment, { children: [Boolean(localFormData && ((_b = Object.keys(localFormData)) === null || _b === void 0 ? void 0 : _b.length)) && (_jsx(Stack, { vertical: true, spacing: "base", children: Object.keys(localFormData).map(function (sectionKey, index) {
                    var _a, _b, _c, _d;
                    var isSaved = savedCosts.includes(sectionKey);
                    return (_jsxs(S.FormWrapper, { isLatest: !isSaved, children: [_jsx(S.Title, { children: "".concat(index + 1, ": ").concat(title) }), _jsxs(Grid, { children: [_jsx(Grid.Item, { width: [1, 1], children: _jsx(TextField, { name: getFieldKey(sectionKey, EAdditionalCostField.Description), error: (_a = validationErrors[sectionKey]) === null || _a === void 0 ? void 0 : _a.description, value: getValue(sectionKey, EAdditionalCostField.Description), label: getLocalizedText("contract_info.description.title"), disabled: isSaved || isExisting, onChange: function (_a) {
                                                var target = _a.target;
                                                handleFieldChange(sectionKey, EAdditionalCostField.Description, target.value);
                                            } }) }), showStartPrice ? (_jsx(Grid.Item, { width: [1, 1 / 2], children: _jsx(TextField, { name: getFieldKey(sectionKey, EAdditionalCostField.StartPrice), error: (_b = validationErrors[sectionKey]) === null || _b === void 0 ? void 0 : _b.startPrice, type: "number", value: getValue(sectionKey, EAdditionalCostField.StartPrice), label: getLocalizedText("contract_info.start_price.title"), disabled: isSaved, placeholder: "0", suffix: "EUR", onChange: function (_a) {
                                                var target = _a.target;
                                                handleFieldChange(sectionKey, EAdditionalCostField.StartPrice, target.value);
                                            } }) })) : (_jsx(Grid.Item, { width: [1, 1 / 2], children: _jsx(TextField, { name: getFieldKey(sectionKey, EAdditionalCostField.CurrentPrice), error: (_c = validationErrors[sectionKey]) === null || _c === void 0 ? void 0 : _c.currentPrice, type: "number", value: getValue(sectionKey, EAdditionalCostField.CurrentPrice), label: getLocalizedText("contract_info.current_price.title"), disabled: isSaved, placeholder: "0", suffix: "EUR", onChange: function (_a) {
                                                var target = _a.target;
                                                handleFieldChange(sectionKey, EAdditionalCostField.CurrentPrice, target.value);
                                            } }) })), _jsx(Grid.Item, { width: [1, 1 / 2], children: _jsx(Select, { id: getFieldKey(sectionKey, EAdditionalCostField.PriceVat), name: getFieldKey(sectionKey, EAdditionalCostField.PriceVat), value: getValue(sectionKey, EAdditionalCostField.PriceVat), disabled: (isExisting &&
                                                getValue(sectionKey, EAdditionalCostField.StartPrice)) ||
                                                isSaved, label: getLocalizedText("contract_info.vat_amount.title"), error: (_d = validationErrors[sectionKey]) === null || _d === void 0 ? void 0 : _d.priceVat, options: (bookkeepingEnabled
                                                ? VAT_OPTIONS_BOOKKEEPING
                                                : VAT_OPTIONS).map(function (id) {
                                                if (isNumber(id)) {
                                                    return {
                                                        value: id,
                                                        id: id,
                                                        label: getLocalizedText("contract.item.vat", { value: "".concat(id) }, id),
                                                    };
                                                }
                                                return {
                                                    value: id,
                                                    id: id,
                                                    label: getLocalizedText("contract.item.no_vat_type.".concat(id).toLowerCase()),
                                                };
                                            }), onChange: function (_a) {
                                                var value = _a.value;
                                                handleFieldChange(sectionKey, EAdditionalCostField.PriceVat, value);
                                            } }) }), _jsxs(Grid.Item, { width: [1, 1 / 2], children: [_jsx(Label, { children: getLocalizedText("contract_info.non_common_costs.price_type.label") }), _jsx(S.InputWrapper, { children: _jsx(SegmentedControl, { name: getFieldKey(sectionKey, EAdditionalCostField.PriceType), selected: getValue(sectionKey, EAdditionalCostField.PriceType) || EContractCostsPriceType.Fixed, disabled: (isExisting &&
                                                        getValue(sectionKey, EAdditionalCostField.StartPrice)) ||
                                                        isSaved, options: [
                                                        EContractCostsPriceType.Fixed,
                                                        EContractCostsPriceType.Provision,
                                                    ].map(function (id) { return ({
                                                        id: id,
                                                        value: getLocalizedText("contract_info.costs.price_type.value.".concat(id.toLowerCase())),
                                                    }); }), onChange: function (value) {
                                                        handleFieldChange(sectionKey, EAdditionalCostField.PriceType, value);
                                                    } }) })] }), _jsxs(Grid.Item, { width: [1, 1 / 2], children: [_jsx(Label, { children: getLocalizedText("contract_info.non_common_costs.are_indexable.label") }), _jsx(S.InputWrapper, { children: _jsx(SegmentedControl, { name: getFieldKey(sectionKey, EAdditionalCostField.IsIndexable), selected: getValue(sectionKey, EAdditionalCostField.IsIndexable) || EContractCostsAreIndexable.No, options: [
                                                        EContractCostsAreIndexable.Yes,
                                                        EContractCostsAreIndexable.No,
                                                    ].map(function (id) { return ({
                                                        id: id,
                                                        value: getLocalizedText("contract_info.costs.are_indexable.value.".concat(id.toLowerCase())),
                                                    }); }), disabled: (isExisting &&
                                                        getValue(sectionKey, EAdditionalCostField.StartPrice)) ||
                                                        isSaved, onChange: function (value) {
                                                        handleFieldChange(sectionKey, EAdditionalCostField.IsIndexable, value);
                                                    } }) })] }), _jsx(Grid.Item, { width: 1, children: _jsxs(Stack, { spacing: "base", children: [!isSaved && (_jsx(Button, { appearance: "primary", onClick: function () { return handleSaveSection(sectionKey); }, children: getLocalizedText("system.save") })), _jsx(Button, { appearance: "danger", onClick: function () { return handleDeleteSection(sectionKey); }, children: getLocalizedText("system.delete") })] }) })] })] }, sectionKey));
                }) })), showAddButton && (_jsx(Button, { isDisabled: uiDisabled, appearance: "outline", onClick: function () {
                    var _a;
                    var newKey = getAdditionalCostsKey(addedAdditionalCostsCount + 1);
                    setLocalFormData(__assign(__assign({}, localFormData), (_a = {}, _a[newKey] = {}, _a)));
                    setAddedAdditionalCostsCount(addedAdditionalCostsCount + 1);
                }, children: buttonTitle }))] }));
};
